import { takeEvery, takeLatest, put, select, call } from 'redux-saga/effects';
import CONSTANTS from '../CONSTANTS';
//Services
import AnalysisService from 'services/AnalysisService';
//Actions
import { 
  actionSetLoadingAnalysisList, 
  actionSetAnalysisList, 
  actionSetStudyTypes,
  actionSetNewPatientData 
} from 'store/actions/analysisActions';

import { getUser } from '../selectors/selectors';
import { toast } from 'react-toastify';

import utilTranslations from '../../helpers/utilTranslations';
import historyRouter from 'historyRouter';
import { actionSetLoadingPatientData } from 'store/actions/analysisActions';

let t;

function* sagaGetAnalysisList({ options }) {
  const userActive = yield select(getUser);
  t = utilTranslations(userActive.language || 'de', 'laboratory-detail');
  const cancelToken = AnalysisService.getSource();

  try {
    yield put(actionSetLoadingAnalysisList(true));

    const entries = yield call(AnalysisService.getAnalysisList, 
      options.practiceId, 
      options.pageIndex, 
      options.pageSize, 
      options.sortDate, 
      options.querySearch, 
      { cancelToken: cancelToken.token }
    );

    if (entries.status >= 400) {
      throw new Error("Error getting analysis list");
    }

    yield put(actionSetAnalysisList(entries.data));
  } catch (er) {
    console.log(er);
    toast.error("Error getting analysis list");
  } finally {
    yield put(actionSetLoadingAnalysisList(false));
  }
}

function* sagaGetStudyTypes() {
  const cancelToken = AnalysisService.getSource();

  try {
    const response = yield call(AnalysisService.getStudyTypes, { cancelToken: cancelToken.token });

    if (response.status >= 400) {
      throw new Error("Error getting study types");
    }

    yield put(actionSetStudyTypes(response.data));
  } catch (e) {
    console.log(e);
    toast.error("Error getting study types");
  }
}

function* sagaSubmitAnalysis({ data }) {
  const cancelToken = AnalysisService.getSource();

  try {
    const response = yield call(AnalysisService.saveAnalysis, data, { cancelToken: cancelToken.token });

    if (response.status >= 400) {
      throw new Error("Error saving the analysis");
    }

    toast.success("Analysis saved");
    yield put(actionSetNewPatientData({}));
    historyRouter.push("/admin/analysis/list");
  } catch (e) {
    console.log(e);
    toast.error("Error saving the analysis");
  }
}

function* sagaInvitePatient({ data }) {
  const cancelToken = AnalysisService.getSource();

  try {
    yield put(actionSetLoadingPatientData(true));
    const response = yield call(AnalysisService.invitePatient, data, { cancelToken: cancelToken.token });

    if (response.status >= 400) {
      throw new Error("Error inviting the patient");
    }

    yield put(actionSetNewPatientData(response.data));
  } catch (e) {
    console.log(e);
    toast.error("Error inviting the patient");
    yield put(actionSetNewPatientData({}));
  } finally {
    yield put(actionSetLoadingPatientData(false));
  }
}

export function* analysisSaga() {
  console.log('*Main Analysis Saga');
  yield takeEvery(CONSTANTS.ANALYSIS_GET_LIST, sagaGetAnalysisList);
  yield takeEvery(CONSTANTS.ANALYSIS_GET_STUDY_TYPES, sagaGetStudyTypes);
  yield takeEvery(CONSTANTS.ANALYSIS_SUBMIT_FORM, sagaSubmitAnalysis);
  yield takeLatest(CONSTANTS.ANALYSIS_INVITE_PATIENT, sagaInvitePatient);
}
